function getFocusableElements(container) {
 return Array.from(
  container.querySelectorAll(
   "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
  ),
 );
}

const HOMEPAGE_CALENDLY_POPUP_URL =
 "https://calendly.com/juanita-mysheepi/new-meeting";
const HOMEPAGE_SLEEP_CONSULT_PATH = "/pages/schlafberatung";
const HOMEPAGE_SLEEP_CONSULT_LABEL = "beratungsgespräch buchen";
const CALENDLY_WIDGET_CSS_URL =
 "https://assets.calendly.com/assets/external/widget.css";
const CALENDLY_WIDGET_JS_URL =
 "https://assets.calendly.com/assets/external/widget.js";
let calendlyWidgetPromise = null;
let calendlyEscapeCloseBound = false;

function isHomepageContext() {
 const bodyClass = document.body ? document.body.className : "";

 return (
  window.location.pathname === "/" ||
  bodyClass.includes("template-index") ||
  bodyClass.includes("homepage_v3")
 );
}

function getNormalizedText(element) {
 return (element.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
}

function isSleepConsultCalendlyTrigger(trigger) {
 if (trigger.hasAttribute("data-calendly-popup-url")) return true;
 if (!isHomepageContext()) return false;

 const href = trigger.getAttribute("href");
 if (!href || getNormalizedText(trigger) !== HOMEPAGE_SLEEP_CONSULT_LABEL) {
  return false;
 }

 try {
  const url = new URL(href, window.location.href);
  const path = url.pathname.replace(/\/$/, "");

  return (
   (url.hostname === "calendly.com" &&
    path === "/juanita-mysheepi/new-meeting") ||
   path === HOMEPAGE_SLEEP_CONSULT_PATH
  );
 } catch (error) {
  return false;
 }
}

function getCalendlyPopupUrl(trigger) {
 return trigger.getAttribute("data-calendly-popup-url") || HOMEPAGE_CALENDLY_POPUP_URL;
}

function loadCalendlyWidget() {
 if (
  window.Calendly &&
  typeof window.Calendly.initPopupWidget === "function"
 ) {
  return Promise.resolve(window.Calendly);
 }

 if (calendlyWidgetPromise) return calendlyWidgetPromise;

 calendlyWidgetPromise = new Promise((resolve, reject) => {
  if (!document.querySelector(`link[href="${CALENDLY_WIDGET_CSS_URL}"]`)) {
   const stylesheet = document.createElement("link");
   stylesheet.rel = "stylesheet";
   stylesheet.href = CALENDLY_WIDGET_CSS_URL;
   document.head.appendChild(stylesheet);
  }

  const resolveCalendly = () => {
   if (
    window.Calendly &&
    typeof window.Calendly.initPopupWidget === "function"
   ) {
    resolve(window.Calendly);
   } else {
    reject(new Error("Calendly widget did not initialize."));
   }
  };

  const existingScript = document.querySelector(
   `script[src="${CALENDLY_WIDGET_JS_URL}"]`,
  );

  if (existingScript) {
   existingScript.addEventListener("load", resolveCalendly, { once: true });
   existingScript.addEventListener("error", reject, { once: true });
   window.setTimeout(resolveCalendly, 5000);
   return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = CALENDLY_WIDGET_JS_URL;
  script.addEventListener("load", resolveCalendly, { once: true });
  script.addEventListener("error", reject, { once: true });
  document.head.appendChild(script);
 }).catch((error) => {
  calendlyWidgetPromise = null;
  throw error;
 });

 return calendlyWidgetPromise;
}

function closeCalendlyPopup() {
 if (
  window.Calendly &&
  typeof window.Calendly.closePopupWidget === "function"
 ) {
  window.Calendly.closePopupWidget();
  return;
 }

 const overlay = document.querySelector(".calendly-overlay");
 if (overlay) overlay.remove();
}

function addCalendlyCloseButton() {
 window.requestAnimationFrame(() => {
  const overlay = document.querySelector(".calendly-overlay");
  if (!overlay) return;

  if (!overlay.dataset.mysheepiCloseBound) {
   overlay.dataset.mysheepiCloseBound = "true";
   overlay.addEventListener("click", (event) => {
    if (event.target === overlay) closeCalendlyPopup();
   });
  }

  if (overlay.querySelector(".mysheepi-calendly-close")) return;

  const closeButton = document.createElement("button");
  const isMobilePopup = window.matchMedia("(max-width: 975px)").matches;
  closeButton.type = "button";
  closeButton.className = "mysheepi-calendly-close";
  closeButton.setAttribute("aria-label", "Calendly Popup schliessen");
  closeButton.textContent = "X";
  closeButton.style.cssText = [
   "position:absolute",
   isMobilePopup ? "top:124px" : "top:14px",
   isMobilePopup ? "right:14px" : "right:14px",
   "z-index:10001",
   isMobilePopup ? "width:44px" : "width:42px",
   isMobilePopup ? "height:44px" : "height:42px",
   isMobilePopup ? "min-width:44px" : "min-width:42px",
   isMobilePopup ? "min-height:44px" : "min-height:42px",
   "box-sizing:border-box",
   "border:0",
   "border-radius:50%",
   "background:#ffffff",
   "color:#111111",
   isMobilePopup ? "font-size:24px" : "font-size:30px",
   "line-height:1",
   "font-weight:500",
   "cursor:pointer",
   "padding:0",
   "text-align:center",
   "display:flex",
   "align-items:center",
   "justify-content:center",
   "box-shadow:0 2px 10px rgba(0,0,0,.2)",
  ].join(";");
  closeButton.addEventListener("click", closeCalendlyPopup);

  overlay.appendChild(closeButton);
 });
}

function enhanceCalendlyPopupCloseControls() {
 addCalendlyCloseButton();

 window.setTimeout(() => {
  if (document.querySelector(".calendly-overlay")) {
   addCalendlyCloseButton();
  }
 }, 500);

 if (calendlyEscapeCloseBound) return;
 calendlyEscapeCloseBound = true;

 document.addEventListener(
  "keydown",
  (event) => {
   if (event.key !== "Escape") return;
   if (!document.querySelector(".calendly-overlay")) return;

   closeCalendlyPopup();
  },
  true,
 );
}

document.addEventListener(
 "click",
 (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest("[data-calendly-popup-url], a[href]");
  if (!trigger || !isSleepConsultCalendlyTrigger(trigger)) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const calendlyUrl = getCalendlyPopupUrl(trigger);

  loadCalendlyWidget()
   .then((Calendly) => {
    Calendly.initPopupWidget({ url: calendlyUrl });
    enhanceCalendlyPopupCloseControls();
   })
   .catch(() => {
    window.location.href = calendlyUrl;
   });
 },
 true,
);

document.querySelectorAll('a[href^="#add-to-cart"]').forEach((anchor) => {
 anchor.addEventListener("click", (event) => {
  event.preventDefault();

  document.querySelector(".product-form__submit").click();
 });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
 summary.setAttribute("role", "button");
 summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

 if (summary.nextElementSibling.getAttribute("id")) {
  summary.setAttribute("aria-controls", summary.nextElementSibling.id);
 }

 summary.addEventListener("click", (event) => {
  event.currentTarget.setAttribute(
   "aria-expanded",
   !event.currentTarget.closest("details").hasAttribute("open"),
  );
 });

 if (summary.closest("header-drawer, menu-drawer")) return;
 summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

document.addEventListener("DOMContentLoaded", () => {
 setTimeout(function () {
  document.querySelectorAll("form.klaviyo-form").forEach(function (form) {
   if (form.querySelector('input[name*="Acquisition"][type="radio"]')) {
    if (window.location.toString().indexOf("google") > -1) {
     if (
      form.querySelector(
       'input[name*="Acquisition"][type="radio"][aria-label="Google"]',
      )
     ) {
      form
       .querySelector(
        'input[name*="Acquisition"][type="radio"][aria-label="Google"]',
       )
       .click();
     }
    }
    if (window.location.toString().indexOf("meta") > -1) {
     if (
      form.querySelector(
       'input[name*="Acquisition"][type="radio"][aria-label="Facebook"]',
      )
     ) {
      form
       .querySelector(
        'input[name*="Acquisition"][type="radio"][aria-label="Facebook"]',
       )
       .click();
     }
    }
    if (window.location.toString().indexOf("youtube") > -1) {
     if (
      form.querySelector(
       'input[name*="Acquisition"][type="radio"][aria-label="Youtube"]',
      )
     ) {
      form
       .querySelector(
        'input[name*="Acquisition"][type="radio"][aria-label="Youtube"]',
       )
       .click();
     }
    }
   }
  });
 }, 5000);


 document
  .querySelectorAll('a[href="#quick-add-to-cart-home-pillow"]')
  .forEach(function (button) {
   button.addEventListener("click", function () {
    if (
     document.querySelector(
      '.u-product-card[href="/products/mysheepi-home-kopfkissen"]',
     )
    ) {
     document
      .querySelector(
       '.u-product-card[href="/products/mysheepi-home-kopfkissen"] .quick-add__submit',
      )
      .click();
    } else {
     window.location = "/products/mysheepi-home-kopfkissen";
    }
   });
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
 var elements = getFocusableElements(container);
 var first = elements[0];
 var last = elements[elements.length - 1];

 removeTrapFocus();

 trapFocusHandlers.focusin = (event) => {
  if (
   event.target !== container &&
   event.target !== last &&
   event.target !== first
  )
   return;

  document.addEventListener("keydown", trapFocusHandlers.keydown);
 };

 trapFocusHandlers.focusout = function () {
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
 };

 trapFocusHandlers.keydown = function (event) {
  if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
  // On the last focusable element and tab forward, focus the first element.
  if (event.target === last && !event.shiftKey) {
   event.preventDefault();
   first.focus();
  }

  //  On the first focusable element and tab backward, focus the last element.
  if (
   (event.target === container || event.target === first) &&
   event.shiftKey
  ) {
   event.preventDefault();
   last.focus();
  }
 };

 document.addEventListener("focusout", trapFocusHandlers.focusout);
 document.addEventListener("focusin", trapFocusHandlers.focusin);

 elementToFocus.focus();

 if (
  elementToFocus.tagName === "INPUT" &&
  ["search", "text", "email", "url"].includes(elementToFocus.type) &&
  elementToFocus.value
 ) {
  elementToFocus.setSelectionRange(0, elementToFocus.value.length);
 }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
 document.querySelector(":focus-visible");
} catch (e) {
 focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
 const navKeys = [
  "ARROWUP",
  "ARROWDOWN",
  "ARROWLEFT",
  "ARROWRIGHT",
  "TAB",
  "ENTER",
  "SPACE",
  "ESCAPE",
  "HOME",
  "END",
  "PAGEUP",
  "PAGEDOWN",
 ];
 let currentFocusedElement = null;
 let mouseClick = null;

 window.addEventListener("keydown", (event) => {
  if (navKeys.includes(event.code.toUpperCase())) {
   mouseClick = false;
  }
 });

 window.addEventListener("mousedown", (event) => {
  mouseClick = true;
 });

 window.addEventListener(
  "focus",
  () => {
   if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

   if (mouseClick) return;

   currentFocusedElement = document.activeElement;
   currentFocusedElement.classList.add("focused");
  },
  true,
 );
}

function pauseAllMedia() {
 document.querySelectorAll(".js-youtube").forEach((video) => {
  video.contentWindow.postMessage(
   '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
   "*",
  );
 });
 document.querySelectorAll(".js-vimeo").forEach((video) => {
  video.contentWindow.postMessage('{"method":"pause"}', "*");
 });
 document.querySelectorAll("video").forEach((video) => video.pause());
 document.querySelectorAll("product-model").forEach((model) => {
  if (model.modelViewerUI) model.modelViewerUI.pause();
 });
}

function removeTrapFocus(elementToFocus = null) {
 document.removeEventListener("focusin", trapFocusHandlers.focusin);
 document.removeEventListener("focusout", trapFocusHandlers.focusout);
 document.removeEventListener("keydown", trapFocusHandlers.keydown);

 if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
 if (event.code.toUpperCase() !== "ESCAPE") return;

 const openDetailsElement = event.target.closest("details[open]");
 if (!openDetailsElement) return;

 const summaryElement = openDetailsElement.querySelector("summary");
 openDetailsElement.removeAttribute("open");
 summaryElement.setAttribute("aria-expanded", false);
 summaryElement.focus();
}

class QuantityInput extends HTMLElement {
 constructor() {
  super();
  this.input = this.querySelector("input");
  this.changeEvent = new Event("change", { bubbles: true });
  this.input.addEventListener("change", this.onInputChange.bind(this));
  this.querySelectorAll("button").forEach((button) =>
   button.addEventListener("click", this.onButtonClick.bind(this)),
  );
 }

 quantityUpdateUnsubscriber = undefined;

 connectedCallback() {
  window.addEventListener(
   "quantity-input-change",
   this.onQuantityInputChange.bind(this),
  );
 }

 disconnectedCallback() {
  window.removeEventListener(
   "quantity-input-change",
   this.onQuantityInputChange.bind(this),
  );
 }

 onInputChange(event) {

  if (!this.input.hasAttribute("data-update-only-self")) {
   const quantityInputChangeEvent = new CustomEvent("quantity-input-change", {
    detail: {
     value: this.input.value,
     variantId: this.input.getAttribute("data-quantity-variant-id"),
    },
   });
   window.dispatchEvent(quantityInputChangeEvent);
  }
 }

 onQuantityInputChange(event) {
  if (
   this.input.value !== event.detail.value &&
   this.input.getAttribute("data-quantity-variant-id") ===
    event.detail.variantId
  ) {
   this.input.value = event.detail.value;
  }
 }

 onButtonClick(event) {
  event.preventDefault();
  const previousValue = this.input.value;

  event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
  if (previousValue !== this.input.value)
   this.input.dispatchEvent(this.changeEvent);
 }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
 let t;
 return (...args) => {
  clearTimeout(t);
  t = setTimeout(() => fn.apply(this, args), wait);
 };
}

function throttle(fn, delay) {
 let lastCall = 0;
 return function (...args) {
  const now = new Date().getTime();
  if (now - lastCall < delay) {
   return;
  }
  lastCall = now;
  return fn(...args);
 };
}

function fetchConfig(type = "json") {
 return {
  method: "POST",
  headers: {
   "Content-Type": "application/json",
   Accept: `application/${type}`,
  },
 };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
 window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
 return function () {
  return fn.apply(scope, arguments);
 };
};

Shopify.setSelectorByValue = function (selector, value) {
 for (var i = 0, count = selector.options.length; i < count; i++) {
  var option = selector.options[i];
  if (value == option.value || value == option.innerHTML) {
   selector.selectedIndex = i;
   return i;
  }
 }
};

Shopify.addListener = function (target, eventName, callback) {
 target.addEventListener
  ? target.addEventListener(eventName, callback, false)
  : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
 options = options || {};
 var method = options["method"] || "post";
 var params = options["parameters"] || {};

 var form = document.createElement("form");
 form.setAttribute("method", method);
 form.setAttribute("action", path);

 for (var key in params) {
  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("type", "hidden");
  hiddenField.setAttribute("name", key);
  hiddenField.setAttribute("value", params[key]);
  form.appendChild(hiddenField);
 }
 document.body.appendChild(form);
 form.submit();
 document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
 country_domid,
 province_domid,
 options,
) {
 this.countryEl = document.getElementById(country_domid);
 this.provinceEl = document.getElementById(province_domid);
 this.provinceContainer = document.getElementById(
  options["hideElement"] || province_domid,
 );

 Shopify.addListener(
  this.countryEl,
  "change",
  Shopify.bind(this.countryHandler, this),
 );

 this.initCountry();
 this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
 initCountry: function () {
  var value = this.countryEl.getAttribute("data-default");
  Shopify.setSelectorByValue(this.countryEl, value);
  this.countryHandler();
 },

 initProvince: function () {
  var value = this.provinceEl.getAttribute("data-default");
  if (value && this.provinceEl.options.length > 0) {
   Shopify.setSelectorByValue(this.provinceEl, value);
  }
 },

 countryHandler: function (e) {
  var opt = this.countryEl.options[this.countryEl.selectedIndex];
  var raw = opt.getAttribute("data-provinces");
  var provinces = JSON.parse(raw);

  this.clearOptions(this.provinceEl);
  if (provinces && provinces.length == 0) {
   this.provinceContainer.style.display = "none";
  } else {
   for (var i = 0; i < provinces.length; i++) {
    var opt = document.createElement("option");
    opt.value = provinces[i][0];
    opt.innerHTML = provinces[i][1];
    this.provinceEl.appendChild(opt);
   }

   this.provinceContainer.style.display = "";
  }
 },

 clearOptions: function (selector) {
  while (selector.firstChild) {
   selector.removeChild(selector.firstChild);
  }
 },

 setOptions: function (selector, values) {
  for (var i = 0, count = values.length; i < values.length; i++) {
   var opt = document.createElement("option");
   opt.value = values[i];
   opt.innerHTML = values[i];
   selector.appendChild(opt);
  }
 },
};

class MenuDrawer extends HTMLElement {
 constructor() {
  super();

  this.mainDetailsToggle = this.querySelector("details");

  this.addEventListener("keyup", this.onKeyUp.bind(this));
  this.addEventListener("focusout", this.onFocusOut.bind(this));
  this.bindEvents();
 }

 bindEvents() {
  this.querySelectorAll("summary").forEach((summary) =>
   summary.addEventListener("click", this.onSummaryClick.bind(this)),
  );
  this.querySelectorAll(
   "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
  ).forEach((button) =>
   button.addEventListener("click", this.onCloseButtonClick.bind(this)),
  );
 }

 onKeyUp(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  openDetailsElement === this.mainDetailsToggle
   ? this.closeMenuDrawer(
      event,
      this.mainDetailsToggle.querySelector("summary"),
     )
   : this.closeSubmenu(openDetailsElement);
 }

 onSummaryClick(event) {
  const summaryElement = event.currentTarget;
  const detailsElement = summaryElement.parentNode;
  const parentMenuElement = detailsElement.closest(".has-submenu");
  const isOpen = detailsElement.hasAttribute("open");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function addTrapFocus() {
   trapFocus(
    summaryElement.nextElementSibling,
    detailsElement.querySelector("button"),
   );
   summaryElement.nextElementSibling.removeEventListener(
    "transitionend",
    addTrapFocus,
   );
  }

  if (detailsElement === this.mainDetailsToggle) {
   if (isOpen) event.preventDefault();
   isOpen
    ? this.closeMenuDrawer(event, summaryElement)
    : this.openMenuDrawer(summaryElement);

   if (window.matchMedia("(max-width: 990px)")) {
    document.documentElement.style.setProperty(
     "--viewport-height",
     `${window.innerHeight}px`,
    );
   }
  } else {
   setTimeout(() => {
    detailsElement.classList.add("menu-opening");
    summaryElement.setAttribute("aria-expanded", true);
    parentMenuElement && parentMenuElement.classList.add("submenu-open");
    !reducedMotion || reducedMotion.matches
     ? addTrapFocus()
     : summaryElement.nextElementSibling.addEventListener(
        "transitionend",
        addTrapFocus,
       );
   }, 100);
  }
 }

 openMenuDrawer(summaryElement) {
  setTimeout(() => {
   this.mainDetailsToggle.classList.add("menu-opening");
  });
  summaryElement.setAttribute("aria-expanded", true);
  trapFocus(this.mainDetailsToggle, summaryElement);
  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
 }

 closeMenuDrawer(event, elementToFocus = false) {
  if (event === undefined) return;

  this.mainDetailsToggle.classList.remove("menu-opening");
  this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
   if (!document.body.classList.contains("variant_b_sticky")) {
    details.removeAttribute("open");
   }
   details.classList.remove("menu-opening");
  });
  this.mainDetailsToggle
   .querySelectorAll(".submenu-open")
   .forEach((submenu) => {
    submenu.classList.remove("submenu-open");
   });
  document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  removeTrapFocus(elementToFocus);
  this.closeAnimation(this.mainDetailsToggle);

  if (event instanceof KeyboardEvent)
   elementToFocus?.setAttribute("aria-expanded", false);
 }

 onFocusOut() {
  setTimeout(() => {
   if (
    this.mainDetailsToggle.hasAttribute("open") &&
    !this.mainDetailsToggle.contains(document.activeElement)
   )
    this.closeMenuDrawer();
  });
 }

 onCloseButtonClick(event) {
  const detailsElement = event.currentTarget.closest("details");
  this.closeSubmenu(detailsElement);
 }

 closeSubmenu(detailsElement) {
  const parentMenuElement = detailsElement.closest(".submenu-open");
  parentMenuElement && parentMenuElement.classList.remove("submenu-open");
  detailsElement.classList.remove("menu-opening");
  detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
  removeTrapFocus(detailsElement.querySelector("summary"));
  this.closeAnimation(detailsElement);
 }

 closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
   if (animationStart === undefined) {
    animationStart = time;
   }

   const elapsedTime = time - animationStart;

   if (elapsedTime < 400) {
    window.requestAnimationFrame(handleAnimation);
   } else {
    detailsElement.removeAttribute("open");
    if (detailsElement.closest("details[open]")) {
     trapFocus(
      detailsElement.closest("details[open]"),
      detailsElement.querySelector("summary"),
     );
    }
   }
  };

  window.requestAnimationFrame(handleAnimation);
 }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
 constructor() {
  super();
 }

 openMenuDrawer(summaryElement) {
  this.header = this.header || document.querySelector(".section-header");
  this.borderOffset =
   this.borderOffset ||
   this.closest(".header-wrapper").classList.contains(
    "header-wrapper--border-bottom",
   )
    ? 1
    : 0;
  document.documentElement.style.setProperty(
   "--header-bottom-position",
   `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
  );
  this.header.classList.add("menu-open");

  setTimeout(() => {
   this.mainDetailsToggle.classList.add("menu-opening");
  });

  summaryElement.setAttribute("aria-expanded", true);
  window.addEventListener("resize", this.onResize);
  trapFocus(this.mainDetailsToggle, summaryElement);
  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  this._lockMenuScroll();
 }

 closeMenuDrawer(event, elementToFocus) {
  if (!elementToFocus) return;
  super.closeMenuDrawer(event, elementToFocus);
  this.header.classList.remove("menu-open");
  window.removeEventListener("resize", this.onResize);
  this._unlockMenuScroll();
 }

 _lockMenuScroll() {
  const navContainer = this.querySelector('.menu-drawer__navigation-container');
  const savedScrollY = window.scrollY;

  this._menuTouchMoveHandler = (e) => {
   if (e.target.closest('.menu-drawer__inner-submenu')) return;
   if (navContainer && navContainer.scrollHeight > navContainer.clientHeight &&
       e.target.closest('.menu-drawer__navigation-container')) return;
   e.preventDefault();
  };
  document.addEventListener('touchmove', this._menuTouchMoveHandler, { passive: false });

  // iOS momentum scroll can bypass touchmove preventDefault — snap back if the page drifts
  this._menuScrollHandler = () => {
   if (window.scrollY !== savedScrollY) {
    window.scrollTo(0, savedScrollY);
   }
  };
  window.addEventListener('scroll', this._menuScrollHandler, { passive: true });
 }

 _unlockMenuScroll() {
  if (this._menuTouchMoveHandler) {
   document.removeEventListener('touchmove', this._menuTouchMoveHandler, { passive: false });
   this._menuTouchMoveHandler = null;
  }
  if (this._menuScrollHandler) {
   window.removeEventListener('scroll', this._menuScrollHandler);
   this._menuScrollHandler = null;
  }
 }

 onResize = () => {
  this.header &&
   document.documentElement.style.setProperty(
    "--header-bottom-position",
    `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
   );
  document.documentElement.style.setProperty(
   "--viewport-height",
   `${window.innerHeight}px`,
  );
 };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
 constructor() {
  super();
  this.querySelector('[id^="ModalClose-"]').addEventListener(
   "click",
   this.hide.bind(this, false),
  );
  this.addEventListener("keyup", (event) => {
   if (event.code.toUpperCase() === "ESCAPE") this.hide();
  });
  if (this.classList.contains("media-modal")) {
   this.addEventListener("pointerup", (event) => {
    if (
     event.pointerType === "mouse" &&
     !event.target.closest("deferred-media, product-model")
    )
     this.hide();
   });
  } else {
   this.addEventListener("click", (event) => {
    if (event.target === this) this.hide();
   });
  }
 }

 connectedCallback() {
  if (this.moved) return;
  this.moved = true;
  document.body.appendChild(this);
 }

 show(opener) {
  this.openedBy = opener;
  const popup = this.querySelector(".template-popup");
  document.body.classList.add("overflow-hidden");
  this.setAttribute("open", "");
  if (popup) popup.loadContent();
  trapFocus(this, this.querySelector('[role="dialog"]'));
  window.pauseAllMedia();
 }

 hide() {
  document.body.classList.remove("overflow-hidden");
  document.body.dispatchEvent(new CustomEvent("modalClosed"));
  this.removeAttribute("open");
  removeTrapFocus(this.openedBy);
  window.pauseAllMedia();
 }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
 constructor() {
  super();

  const button = this.querySelector("button");

  if (!button) return;
  button.addEventListener("click", (event) => {
   event.preventDefault();

   const modal = document.querySelector(this.getAttribute("data-modal"));
   if (modal) modal.show(button);
  });
 }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
 constructor() {
  super();
  const poster = this.querySelector('[id^="Deferred-Poster-"]');
  if (!poster) return;
  poster.addEventListener("click", this.loadContent.bind(this));
 }

 loadContent(focus = true) {
  window.pauseAllMedia();
  if (!this.getAttribute("loaded")) {
   const content = document.createElement("div");
   content.appendChild(
    this.querySelector("template").content.firstElementChild.cloneNode(true),
   );

   this.setAttribute("loaded", true);
   const deferredElement = this.appendChild(
    content.querySelector("video, model-viewer, iframe"),
   );
   if (focus) deferredElement.focus();
   if (
    deferredElement.nodeName == "VIDEO" &&
    deferredElement.getAttribute("autoplay")
   ) {
    // force autoplay for safari
    deferredElement.play();
   }
  }
 }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
 constructor() {
  super();
  this.slider = this.querySelector('[id^="Slider-"]');
  this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  this.enableSliderLooping = false;
  this.currentPageElement = this.querySelector(".slider-counter--current");
  this.pageTotalElement = this.querySelector(".slider-counter--total");
  this.prevButton = this.querySelector('button[name="previous"]');
  this.nextButton = this.querySelector('button[name="next"]');

  if (!this.slider || !this.nextButton) return;

  this.initPages();
  const resizeObserver = new ResizeObserver((entries) => this.initPages());
  resizeObserver.observe(this.slider);

  this.slider.addEventListener("scroll", this.update.bind(this));
  this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
  this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
 }

 initPages() {
  this.sliderItemsToShow = Array.from(this.sliderItems).filter(
   (element) => element.clientWidth > 0,
  );
  if (this.sliderItemsToShow.length < 2) return;
  this.sliderItemOffset =
   this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
  this.slidesPerPage = Math.floor(
   (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
    this.sliderItemOffset,
  );
  this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
  this.update();
 }

 resetPages() {
  this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  this.initPages();
 }

 update() {
  // Temporarily prevents unneeded updates resulting from variant changes
  // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
  if (!this.slider || !this.nextButton) return;

  const previousPage = this.currentPage;
  this.currentPage =
   Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

  if (this.currentPageElement && this.pageTotalElement) {
   this.currentPageElement.textContent = this.currentPage;
   this.pageTotalElement.textContent = this.totalPages;
  }

  if (this.currentPage != previousPage) {
   this.dispatchEvent(
    new CustomEvent("slideChanged", {
     detail: {
      currentPage: this.currentPage,
      currentElement: this.sliderItemsToShow[this.currentPage - 1],
     },
    }),
   );
  }

  if (this.enableSliderLooping) return;

  if (
   this.isSlideVisible(this.sliderItemsToShow[0]) &&
   this.slider.scrollLeft === 0
  ) {
   this.prevButton.setAttribute("disabled", "disabled");
  } else {
   this.prevButton.removeAttribute("disabled");
  }

  if (
   this.isSlideVisible(
    this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
   )
  ) {
   this.nextButton.setAttribute("disabled", "disabled");
  } else {
   this.nextButton.removeAttribute("disabled");
  }
 }

 isSlideVisible(element, offset = 0) {
  const sliderElement = this.slider;
  const lastVisibleSlide =
   sliderElement.clientWidth + sliderElement.scrollLeft - offset;
  return (
   element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
   element.offsetLeft >= sliderElement.scrollLeft
  );
 }

 onButtonClick(event) {
  event.preventDefault();
  const step = event.currentTarget.dataset.step || 1;
  this.slideScrollPosition =
   event.currentTarget.name === "next"
    ? this.slider.scrollLeft + step * this.sliderItemOffset
    : this.slider.scrollLeft - step * this.sliderItemOffset;
  this.setSlidePosition(this.slideScrollPosition);
 }

 setSlidePosition(position) {
  this.slider.scrollTo({
   left: position,
  });
 }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
 constructor() {
  super();
  this.sliderControlWrapper = this.querySelector(".slider-buttons");
  this.enableSliderLooping = true;

  if (!this.sliderControlWrapper) return;

  this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
  if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

  this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
  // Value below should match --duration-announcement-bar CSS value
  this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

  this.sliderControlLinksArray = Array.from(
   this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
  );
  this.sliderControlLinksArray.forEach((link) =>
   link.addEventListener("click", this.linkToSlide.bind(this)),
  );
  this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
  this.setSlideVisibility();

  if (this.announcementBarSlider) {
   this.announcementBarArrowButtonWasClicked = false;

   this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
   this.reducedMotion.addEventListener("change", () => {
    if (this.slider.getAttribute("data-autoplay") === "true")
     this.setAutoPlay();
   });

   [this.prevButton, this.nextButton].forEach((button) => {
    button.addEventListener(
     "click",
     () => {
      this.announcementBarArrowButtonWasClicked = true;
     },
     { once: true },
    );
   });
  }

  if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
 }

 setAutoPlay() {
  this.autoplaySpeed = this.slider.dataset.speed * 1000;
  this.addEventListener("mouseover", this.focusInHandling.bind(this));
  this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
  this.addEventListener("focusin", this.focusInHandling.bind(this));
  this.addEventListener("focusout", this.focusOutHandling.bind(this));

  if (this.querySelector(".slideshow__autoplay")) {
   this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
   this.sliderAutoplayButton.addEventListener(
    "click",
    this.autoPlayToggle.bind(this),
   );
   this.autoplayButtonIsSetToPlay = true;
   this.play();
  } else {
   this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
    ? this.pause()
    : this.play();
  }
 }

 onButtonClick(event) {
  super.onButtonClick(event);
  this.wasClicked = true;

  const isFirstSlide = this.currentPage === 1;
  const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

  if (!isFirstSlide && !isLastSlide) {
   this.applyAnimationToAnnouncementBar(event.currentTarget.name);
   return;
  }

  if (isFirstSlide && event.currentTarget.name === "previous") {
   this.slideScrollPosition =
    this.slider.scrollLeft +
    this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
  } else if (isLastSlide && event.currentTarget.name === "next") {
   this.slideScrollPosition = 0;
  }

  this.setSlidePosition(this.slideScrollPosition);

  this.applyAnimationToAnnouncementBar(event.currentTarget.name);
 }

 setSlidePosition(position) {
  if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
  this.setPositionTimeout = setTimeout(() => {
   this.slider.scrollTo({
    left: position,
   });
  }, this.announcerBarAnimationDelay);
 }

 update() {
  super.update();
  this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
  this.prevButton.removeAttribute("disabled");

  if (!this.sliderControlButtons.length) return;

  this.sliderControlButtons.forEach((link) => {
   link.classList.remove("slider-counter__link--active");
   link.removeAttribute("aria-current");
  });
  this.sliderControlButtons[this.currentPage - 1].classList.add(
   "slider-counter__link--active",
  );
  this.sliderControlButtons[this.currentPage - 1].setAttribute(
   "aria-current",
   true,
  );
 }

 autoPlayToggle() {
  this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
  this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
  this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
 }

 focusOutHandling(event) {
  if (this.sliderAutoplayButton) {
   const focusedOnAutoplayButton =
    event.target === this.sliderAutoplayButton ||
    this.sliderAutoplayButton.contains(event.target);
   if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
   this.play();
  } else if (
   !this.reducedMotion.matches &&
   !this.announcementBarArrowButtonWasClicked
  ) {
   this.play();
  }
 }

 focusInHandling(event) {
  if (this.sliderAutoplayButton) {
   const focusedOnAutoplayButton =
    event.target === this.sliderAutoplayButton ||
    this.sliderAutoplayButton.contains(event.target);
   if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
    this.play();
   } else if (this.autoplayButtonIsSetToPlay) {
    this.pause();
   }
  } else if (this.announcementBarSlider.contains(event.target)) {
   this.pause();
  }
 }

 play() {
  this.slider.setAttribute("aria-live", "off");
  clearInterval(this.autoplay);
  this.autoplay = setInterval(
   this.autoRotateSlides.bind(this),
   this.autoplaySpeed,
  );
 }

 pause() {
  this.slider.setAttribute("aria-live", "polite");
  clearInterval(this.autoplay);
 }

 togglePlayButtonState(pauseAutoplay) {
  if (pauseAutoplay) {
   this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
   this.sliderAutoplayButton.setAttribute(
    "aria-label",
    window.accessibilityStrings.playSlideshow,
   );
  } else {
   this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
   this.sliderAutoplayButton.setAttribute(
    "aria-label",
    window.accessibilityStrings.pauseSlideshow,
   );
  }
 }

 autoRotateSlides() {
  const slideScrollPosition =
   this.currentPage === this.sliderItems.length
    ? 0
    : this.slider.scrollLeft + this.sliderItemOffset;

  this.setSlidePosition(slideScrollPosition);
  this.applyAnimationToAnnouncementBar();
 }

 setSlideVisibility(event) {
  this.sliderItemsToShow.forEach((item, index) => {
   const linkElements = item.querySelectorAll("a");
   if (index === this.currentPage - 1) {
    if (linkElements.length)
     linkElements.forEach((button) => {
      button.removeAttribute("tabindex");
     });
    item.setAttribute("aria-hidden", "false");
    item.removeAttribute("tabindex");
   } else {
    if (linkElements.length)
     linkElements.forEach((button) => {
      button.setAttribute("tabindex", "-1");
     });
    item.setAttribute("aria-hidden", "true");
    item.setAttribute("tabindex", "-1");
   }
  });
  this.wasClicked = false;
 }

 applyAnimationToAnnouncementBar(button = "next") {
  if (!this.announcementBarSlider) return;

  const itemsCount = this.sliderItems.length;
  const increment = button === "next" ? 1 : -1;

  const currentIndex = this.currentPage - 1;
  let nextIndex = (currentIndex + increment) % itemsCount;
  nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

  const nextSlide = this.sliderItems[nextIndex];
  const currentSlide = this.sliderItems[currentIndex];

  const animationClassIn = "announcement-bar-slider--fade-in";
  const animationClassOut = "announcement-bar-slider--fade-out";

  const isFirstSlide = currentIndex === 0;
  const isLastSlide = currentIndex === itemsCount - 1;

  const shouldMoveNext =
   (button === "next" && !isLastSlide) ||
   (button === "previous" && isFirstSlide);
  const direction = shouldMoveNext ? "next" : "previous";

  currentSlide.classList.add(`${animationClassOut}-${direction}`);
  nextSlide.classList.add(`${animationClassIn}-${direction}`);

  setTimeout(() => {
   currentSlide.classList.remove(`${animationClassOut}-${direction}`);
   nextSlide.classList.remove(`${animationClassIn}-${direction}`);
  }, this.announcerBarAnimationDelay * 2);
 }

 linkToSlide(event) {
  event.preventDefault();
  const slideScrollPosition =
   this.slider.scrollLeft +
   this.sliderFirstItemNode.clientWidth *
    (this.sliderControlLinksArray.indexOf(event.currentTarget) +
     1 -
     this.currentPage);
  this.slider.scrollTo({
   left: slideScrollPosition,
  });
 }
}

customElements.define("slideshow-component", SlideshowComponent);

class CustomDialog extends HTMLElement {
 constructor() {
  super();

  this.dialog = this.querySelector("dialog");

  this.cart =
   document.querySelector("cart-notification") ||
   document.querySelector("cart-drawer");

  this.dialog.addEventListener("click", (e) => {
   if (e.target === e.currentTarget) {
    this.closeModal();
   }
  });
 }

 connectedCallback() {
  document.addEventListener("click", this.handleDocumentClick.bind(this));
 }

 disconnectedCallback() {
  document.removeEventListener("click", this.handleDocumentClick.bind(this));
 }

 saveCartData = (cartData) => {
  this.cartData = cartData;
 };

 openModal() {
  document.querySelector("body").classList.add("overflow-hidden");
  this.dialog.showModal();
  this.classList.add("modal--open");
 }

 closeModal() {
  this.classList.remove("modal--open");
  this.dialog.classList.add("animate-close");

  // const that = this;

  setTimeout(() => {
   if (this.querySelector(".upsell_modal_container")) {
    this.cart.renderContents(this.cartData);
   }

   document.querySelector("body").classList.remove("overflow-hidden");
   this.dialog.close();
   this.dialog.innerHTML = "";
   this.dialog.classList.remove("animate-close");
  }, 200);
 }

 handleDocumentClick(event) {
  const target = event.target;

  if (target.closest(".modal__close") || target.closest(".modal_btn")) {
   this.closeModal();
  }
 }
}

customElements.define("custom-dialog", CustomDialog);

class VariantSelects extends HTMLElement {
 constructor() {
  super();
  this.addEventListener("change", this.onVariantChange);
 }

 connectedCallback() {
  // Keep hidden variant inputs and add-to-cart state in sync on first render.
  this.initializeVariantState();

  // Some PDP customizations hydrate after connect and can leave the first
  // render with a visually selected option but no resolved variant yet.
  [0, 80, 220, 500].forEach((delay) => {
   window.setTimeout(() => {
    this.initializeVariantState();
   }, delay);
  });
 }

 initializeVariantState() {
  this.ensureAvailableVariantSelected();
  this.ensureCheckedInputsMatchResolvedVariant();
  this.syncInitialVariantState();
 }

 /**
  * Select the first visible available variant when the initial variant is hidden or unavailable.
  */
 ensureAvailableVariantSelected() {
  if (!this.getVariantData) return;
  const variants = this.getVariantData();
  if (!variants || !Array.isArray(variants) || variants.length === 0) return;
  this.updateOptions();
  const requestedVariant = this.getVariantRequestedInUrl(variants);
  let variantToSelect = null;

  if (requestedVariant && this.variantOptionsAreVisible(requestedVariant)) {
   variantToSelect = requestedVariant;
  }

  if (!variantToSelect) {
   variantToSelect = this.getFirstAvailableVisibleVariant(variants);
  }

  if (!variantToSelect) {
   variantToSelect = this.getFirstVisibleVariant(variants);
  }

  if (!variantToSelect) {
   variantToSelect = variants.find((variant) => variant.available) || variants[0];
  }

  if (variantToSelect) {
   this.applyVariantSelection(variantToSelect);
  }
 }

 getVariantRequestedInUrl(variants) {
  const params = new URLSearchParams(window.location.search);
  const requestedVariantId = Number(params.get("variant"));

  if (!Number.isFinite(requestedVariantId) || requestedVariantId <= 0) return null;

  return variants.find((variant) => variant.id === requestedVariantId) || null;
 }

 getVisibleOptionValues() {
  return Array.from(this.querySelectorAll("select, fieldset"), (input) => {
   if (input.tagName === "SELECT") {
    return Array.from(input.options).map((option) => option.value);
   }

   if (input.tagName === "FIELDSET") {
    return Array.from(input.querySelectorAll('input[type="radio"]')).map(
     (radio) => radio.value,
    );
   }

   return [];
  });
 }

 variantOptionsAreVisible(variant) {
  if (!variant?.options || !Array.isArray(variant.options)) return false;

  const visibleOptionValues = this.getVisibleOptionValues();
  return variant.options.every((optionValue, index) =>
   visibleOptionValues[index]?.includes(optionValue),
  );
 }

 getFirstAvailableVisibleVariant(variants) {
  return (
   variants.find(
    (variant) => variant.available && this.variantOptionsAreVisible(variant),
   ) || null
  );
 }

 getFirstVisibleVariant(variants) {
  return variants.find((variant) => this.variantOptionsAreVisible(variant)) || null;
 }

 applyVariantSelection(variantToSelect) {
  if (!variantToSelect?.options || !Array.isArray(variantToSelect.options)) return;

  const optionInputs = this.querySelectorAll("select, fieldset");
  variantToSelect.options.forEach((optionValue, idx) => {
   const input = optionInputs[idx];
   if (!input) return;

   if (input.tagName === "SELECT") {
    if (input.value !== optionValue) {
     input.value = optionValue;
    }
    this.updateSelectedSwatchValue({ target: input });
    return;
   }

   if (input.tagName === "FIELDSET") {
    const radio = Array.from(input.querySelectorAll('input[type="radio"]')).find(
     (item) => item.value === optionValue,
    );
    if (radio) {
     radio.checked = true;
     this.updateSelectedSwatchValue({ target: radio });
    }
   }
  });

  this.updateOptions();
  this.updateMasterId();
 }

 ensureCheckedInputsMatchResolvedVariant() {
  this.updateOptions();
  this.updateMasterId();

  if (this.currentVariant && this.variantOptionsAreVisible(this.currentVariant)) return;

  const variants = this.getVariantData();
  if (!variants || !Array.isArray(variants) || variants.length === 0) return;

  const firstAvailableVariant =
   this.getFirstAvailableVisibleVariant(variants) ||
   this.getFirstVisibleVariant(variants);
  if (!firstAvailableVariant) return;

  this.applyVariantSelection(firstAvailableVariant);
 }

  onVariantChange(event) {
    // Save previous options for comparison
    const prevOptions = this.options ? [...this.options] : [];
    this.updateOptions();
    const prevVariant = this.currentVariant;
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.showHelperInfo(event);

    // Enhanced logic: if option 1 (color) changed, and current size is unavailable, auto-select first available size for that color
    const variantData = this.getVariantData();
    if (event && event.target && (event.target.name?.includes('options[0]') || event.target.closest('fieldset')?.querySelector('legend')?.textContent?.toLowerCase().includes('farbe'))) {
      // Option 1 (color) changed
      const selectedColor = this.options[0];
      const selectedSize = this.options[1];
      // Find all variants for this color
      const colorVariants = variantData.filter(v => v.option1 === selectedColor);
      // If current size is unavailable for this color, select first available size
      const matchingVariant = colorVariants.find(v => v.option2 === selectedSize);
      if (!matchingVariant || !matchingVariant.available) {
        const firstAvailable = colorVariants.find(v => v.available);
        if (firstAvailable) {
          // Set size select/radio to first available
          const sizeInputWrapper = this.querySelectorAll('.product-form__input')[1];
          if (sizeInputWrapper) {
            if (sizeInputWrapper.tagName === 'FIELDSET') {
              const radio = Array.from(sizeInputWrapper.querySelectorAll('input[type="radio"]')).find(r => r.value === firstAvailable.option2);
              if (radio && !radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else {
              const select = sizeInputWrapper.querySelector('select');
              if (select) {
                select.value = firstAvailable.option2;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          // Update options and variant
          this.updateOptions();
          this.updateMasterId();
        }
        // If no available size exists for the selected color, do nothing.
        // The user explicitly chose this color — respect that and show the notify-me / sold-out state.
      }
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      const variantDescription = document.querySelectorAll(
        ".variant_description_info",
      );
      variantDescription.forEach((item) => {
        if (this.currentVariant.id === +item.getAttribute("data-variant-id")) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });

      const productInfoContainer = this.closest("product-info.product__info-container");
      const atc_button = productInfoContainer?.querySelector(".product-form__submit");
      const sticky_atc_button = document.querySelector(
        "[data-sticky-add] .product-form__submit",
      );
      if (atc_button?.dataset?.productBaseUrl) {
        const new_variant_url = `${atc_button.dataset.productBaseUrl}?variant=${this.currentVariant.id}`;
        atc_button.setAttribute("data-product-url", new_variant_url);
        sticky_atc_button?.setAttribute("data-product-url", new_variant_url);
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

 syncInitialVariantState() {
  this.updateOptions();
  this.updateMasterId();
  this.updateVariantStatuses();

  if (!this.currentVariant) {
   this.toggleAddButton(true, "", true);
   this.setUnavailable();
   return;
  }

  this.updateVariantInput();
  this.updatePickupAvailability();
  if (this.dataset.productHandle === "mysheepi-seidenschlafmaske") this.updateMedia();

  if (this.currentVariant.available) {
   this.toggleAddButton(false, "", true);
  } else {
   this.toggleAddButton(true, window.variantStrings.soldOut, true);
  }
 }

 showHelperInfo(event) {
  if (event.target.tagName === "INPUT") {
   console.log(
    this.querySelectorAll(
     'helper-info-popover[data-option-name="' +
      event.target.name +
      '"]:not(.hidden)',
    ),
   );
   this.querySelectorAll(
    'helper-info-popover[data-option-name="' +
     event.target.name +
     '"]:not(.hidden)',
   ).forEach((info) => {
    info.classList.add("hidden");
   });
   this.querySelectorAll(
    'helper-info-popover[data-option-name="' +
     event.target.name +
     '"][data-option-value="' +
     event.target.value +
     '"]',
   ).forEach((info) => {
    info.classList.remove("hidden");
   });
  }
 }

 updateOptions() {
  this.options = Array.from(
   this.querySelectorAll("select, fieldset"),
   (element) => {
    if (element.tagName === "SELECT") {
     return element.value;
    }
    if (element.tagName === "FIELDSET") {
     return Array.from(element.querySelectorAll("input")).find(
      (radio) => radio.checked,
     )?.value;
    }
   },
  );
 }

 updateMasterId() {
  this.currentVariant = this.getVariantData().find((variant) => {
   return !variant.options
    .map((option, index) => {
     return this.options[index] === option;
    })
    .includes(false);
  });
 }

 updateSelectedSwatchValue({ target }) {
  const { name, value, tagName } = target;

  if (tagName === "SELECT" && target.selectedOptions.length) {
   const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
   const selectedDropdownSwatchValue = this.querySelector(
    `[data-selected-dropdown-swatch="${name}"] > .swatch`,
   );
   if (!selectedDropdownSwatchValue) return;
   if (swatchValue) {
    selectedDropdownSwatchValue.style.setProperty(
     "--swatch--background",
     swatchValue,
    );
    selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
   } else {
    selectedDropdownSwatchValue.style.setProperty(
     "--swatch--background",
     "unset",
    );
    selectedDropdownSwatchValue.classList.add("swatch--unavailable");
   }
  } else if (tagName === "INPUT" && target.type === "radio") {
   const selectedSwatchValue = this.querySelector(
    `[data-selected-swatch-value="${name}"]`,
   );
   if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
  }
 }

 getSleepingMaskColorImage() {
  if (this.dataset.productHandle !== "mysheepi-seidenschlafmaske") return null;

  const imageByColor = {
   elfenbein:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-beige_992d42a3-e955-415a-824f-920aa123babc.png?v=1766997103",
   beige:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-beige_992d42a3-e955-415a-824f-920aa123babc.png?v=1766997103",
   ivory:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-beige_992d42a3-e955-415a-824f-920aa123babc.png?v=1766997103",
   grau:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Grau_d58d7e79-3053-4446-aa4a-8200631350a9.png?v=1766997103",
   grey:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Grau_d58d7e79-3053-4446-aa4a-8200631350a9.png?v=1766997103",
   gray:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Grau_d58d7e79-3053-4446-aa4a-8200631350a9.png?v=1766997103",
   hellrosa:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-HellRosa_eec54585-e940-448b-aa5e-686f16e9524c.png?v=1766997103",
   lightpink:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-HellRosa_eec54585-e940-448b-aa5e-686f16e9524c.png?v=1766997103",
   marineblau:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Navy_09d79f7f-cf3f-4100-87b4-6648a0913fd2.png?v=1766997103",
   navy:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Navy_09d79f7f-cf3f-4100-87b4-6648a0913fd2.png?v=1766997103",
   navyblue:
    "https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-seidenschlafmaske-introbild-Navy_09d79f7f-cf3f-4100-87b4-6648a0913fd2.png?v=1766997103",
  };

  const selectedOptions =
   this.currentVariant?.options && Array.isArray(this.currentVariant.options)
    ? this.currentVariant.options
    : this.options || [];

  for (const value of selectedOptions) {
   const colorKey = String(value || "")
    .toLowerCase()
    .replace(/weiß/g, "weiss")
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/standard|kompakt/g, "")
    .replace(/[^a-z0-9]+/g, "");

   if (imageByColor[colorKey]) return imageByColor[colorKey];
  }

  return null;
 }

 getResizedImageUrl(src, width) {
  if (!src) return "";
  const separator = src.includes("?") ? "&" : "?";
  return `${src}${separator}width=${width}`;
 }

 updateImageElementSource(image, src, widths) {
  if (!(image instanceof HTMLImageElement) || !src) return;

  const imageWidths = widths || [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
  image.src = this.getResizedImageUrl(src, imageWidths[imageWidths.length - 1]);
  image.srcset = imageWidths
   .map((width) => `${this.getResizedImageUrl(src, width)} ${width}w`)
   .join(", ");
  image.alt = this.currentVariant?.featured_image?.alt || "mysheepi Seidenschlafmaske";
 }

 updateSleepingMaskMedia() {
  const imageSrc = this.getSleepingMaskColorImage();
  if (!imageSrc) return false;

  const mediaGalleries = document.querySelectorAll(
   `[id^="MediaGallery-${this.dataset.section}"]`,
  );
  mediaGalleries.forEach((mediaGallery) => {
   const firstMedia = mediaGallery.querySelector("[data-media-id]");
   firstMedia?.querySelectorAll("img").forEach((image) => {
    this.updateImageElementSource(image, imageSrc);
   });

   const firstThumbnail = mediaGallery.querySelector("[data-target] img");
   this.updateImageElementSource(firstThumbnail, imageSrc, [54, 74, 104, 162, 208, 324, 416]);

   if (firstMedia?.dataset.mediaId && typeof mediaGallery.setActiveMedia === "function") {
    mediaGallery.setActiveMedia(firstMedia.dataset.mediaId, false);
   }
  });

  const modal = document.querySelector(`#ProductModal-${this.dataset.section}`);
  const modalFirstSlide = modal?.querySelector(".product-media-modal__slide");
  modalFirstSlide?.querySelectorAll("img").forEach((image) => {
   this.updateImageElementSource(image, imageSrc);
  });

  const modalFirstThumbnail = modal?.querySelector(".product-media-modal__thumbnail img");
  this.updateImageElementSource(modalFirstThumbnail, imageSrc, [88, 110, 176, 220]);

  return true;
 }

 updateMedia() {
  if (!this.currentVariant) return;
  if (this.dataset.productHandle === "mysheepi-seidenschlafmaske" && this.updateSleepingMaskMedia()) return;
  if (!this.currentVariant.featured_media) return;

  const mediaGalleries = document.querySelectorAll(
   `[id^="MediaGallery-${this.dataset.section}"]`,
  );
  mediaGalleries.forEach((mediaGallery) =>
   mediaGallery.setActiveMedia(
    `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
    true,
   ),
  );

  const modalContent = document.querySelector(
   `#ProductModal-${this.dataset.section} .product-media-modal__content`,
  );
  if (!modalContent) return;
  const modalViewer = modalContent.querySelector(".product-media-modal__viewer");
  const modalThumbnailList = modalContent.querySelector(".product-media-modal__thumbnail-list");
  const newMediaModal = modalViewer?.querySelector(
   `[data-media-id="${this.currentVariant.featured_media.id}"]`,
  );
  const newMediaModalThumbnail = modalThumbnailList?.querySelector(
   `[data-target="${this.currentVariant.featured_media.id}"]`,
  );

  if (newMediaModal) modalViewer.prepend(newMediaModal);
  if (newMediaModalThumbnail) modalThumbnailList.prepend(newMediaModalThumbnail);
 }

 updateURL() {
  if (!this.currentVariant || this.dataset.updateUrl === "false") return;
  window.history.replaceState(
   {},
   "",
   `${this.dataset.url}?variant=${this.currentVariant.id}`,
  );
  window.dispatchEvent(
   new CustomEvent("urlUpdate", {
    detail: { url: `${this.dataset.url}?variant=${this.currentVariant.id}` },
   }),
  );
 }

 updateShareUrl() {
  const shareButton = document.getElementById(`Share-${this.dataset.section}`);
  if (!shareButton || !shareButton.updateUrl) return;
  shareButton.updateUrl(
   `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
  );
 }

 updateVariantInput() {
  const productForms = document.querySelectorAll(
   `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, [data-sticky-add]`,
  );
  productForms.forEach((productForm) => {
   const input = productForm.querySelector('input[name="id"]');
   input.value = this.currentVariant.id;
   input.dispatchEvent(new Event("change", { bubbles: true }));
  });
 }

 updateVariantStatuses() {
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
   const optionInputs = [
    ...option.querySelectorAll('input[type="radio"], option'),
   ];

   const availableOptionInputsValue = this.variantData
    .filter((variant) => {
     if (!variant.available) return false;

     return this.options.every((selectedOption, optionIndex) => {
      const variantOption =
       variant.options?.[optionIndex] || variant[`option${optionIndex + 1}`];

      if (optionIndex === index) return true;
      if (!selectedOption) return true;

      return variantOption === selectedOption;
     });
    })
    .map((variantOption) =>
     variantOption.options?.[index] || variantOption[`option${index + 1}`],
    );

   this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
 }

 setInputAvailability(elementList, availableValuesList) {
  elementList.forEach((element) => {
   const value = element.getAttribute("value");
   const availableElement = availableValuesList.includes(value);

   if (element.tagName === "INPUT") {
    element.classList.toggle("disabled", !availableElement);
   } else if (element.tagName === "OPTION") {
    element.innerText = availableElement
     ? value
     : window.variantStrings.unavailable_with_option.replace("[value]", value);
   }
  });
 }

 updatePickupAvailability() {
  const pickUpAvailability = document.querySelector("pickup-availability");
  if (!pickUpAvailability) return;

  if (this.currentVariant && this.currentVariant.available) {
   pickUpAvailability.fetchAvailability(this.currentVariant.id);
  } else {
   pickUpAvailability.removeAttribute("available");
   pickUpAvailability.innerHTML = "";
  }
 }

 removeErrorMessage() {
  const section = this.closest("section");
  if (!section) return;

  const productForm = section.querySelector("product-form");
  if (productForm) productForm.handleErrorMessage();
 }

 renderProductInfo() {
  const requestedVariantId = this.currentVariant.id;
  const sectionId = this.dataset.originalSection
   ? this.dataset.originalSection
   : this.dataset.section;

  fetch(
   `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
    this.dataset.originalSection
     ? this.dataset.originalSection
     : this.dataset.section
   }`,
  )
   .then((response) => response.text())
   .then((responseText) => {
    // prevent unnecessary ui changes from abandoned selections
    if (this.currentVariant.id !== requestedVariantId) return;

    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(
     `price-${this.dataset.section}`,
    );
    const source = html.getElementById(
     `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    );
    const skuSource = html.getElementById(
     `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    );
    const skuDestination = document.getElementById(
     `Sku-${this.dataset.section}`,
    );
    const inventorySource = html.getElementById(
     `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    );
    const inventoryDestination = document.getElementById(
     `Inventory-${this.dataset.section}`,
    );

    const volumePricingSource = html.getElementById(
     `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    );

    const pricePerItemDestinations = document.querySelectorAll(
     `#price-${this.dataset.section}`,
    );
    const pricePerItemSource = html.getElementById(
     `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    );

    const volumePricingDestination = document.getElementById(
     `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
     `Quantity-Rules-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
     `Volume-Note-${this.dataset.section}`,
    );

    if (volumeNote) volumeNote.classList.remove("hidden");
    if (volumePricingDestination)
     volumePricingDestination.classList.remove("hidden");
    if (qtyRules) qtyRules.classList.remove("hidden");

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (inventorySource && inventoryDestination)
     inventoryDestination.innerHTML = inventorySource.innerHTML;
    if (skuSource && skuDestination) {
     skuDestination.innerHTML = skuSource.innerHTML;
     skuDestination.classList.toggle(
      "hidden",
      skuSource.classList.contains("hidden"),
     );
    }

    if (volumePricingSource && volumePricingDestination) {
     volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
    }

    if (pricePerItemSource && pricePerItemDestinations) {
     pricePerItemDestinations.forEach(function (pricePerItemDestination) {
      pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
      pricePerItemDestination.classList.toggle(
       "hidden",
       pricePerItemSource.classList.contains("hidden"),
      );
     });
    }

    const price = document.getElementById(`price-${this.dataset.section}`);

    if (price) {
     price.classList.remove("hidden");

     const priceClone = price.children[0].cloneNode(true);
     priceClone.classList.remove("price--large");

     const stickyPrices = document.querySelectorAll(`[data-stickyAdd-price]`);
     if (stickyPrices) {
      stickyPrices.forEach((stickyPrice) => {
       stickyPrice.innerHTML = priceClone.outerHTML;
       stickyPrice.dataset.unitPrice = priceClone.dataset.priceCents || "";
       stickyPrice.dataset.unitCompareAtPrice =
        priceClone.dataset.compareAtPriceCents || "";
      });
      document.dispatchEvent(new CustomEvent("sticky-atc:price-unit-change"));
     }
    }

    if (inventoryDestination)
     inventoryDestination.classList.toggle(
      "hidden",
      inventorySource.innerText === "",
     );

    const addButtonUpdated = html.getElementById(
     `ProductSubmitButton-${sectionId}`,
    );
    this.toggleAddButton(
     addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
     window.variantStrings.soldOut,
    );

    if (document.querySelector("sticky-atc .product-variant-id")) {
     let productVariantId = document.querySelector(
      "sticky-atc .product-variant-id",
     );
     productVariantId.value = requestedVariantId;
     productVariantId.dispatchEvent(
      new CustomEvent("change", { bubbles: true }),
     );
    }
    document
     .querySelector("product-info .quantity__input")
     .dispatchEvent(new CustomEvent("change", { bubbles: true }));
   });
 }

 toggleAddButton(disable = true, text, modifyClass = true) {
  const productForm = document.getElementById(
   `product-form-${this.dataset.section}`,
  );
  if (!productForm) return;
  const addButton = productForm.querySelector('[name="add"]');
  const pdpButtons = productForm.querySelector(".buy-button__wrapper");
  const addButtonText = productForm.querySelector('[name="add"] > span');
  if (!addButton) return;

  if (disable) {
   addButton.setAttribute("disabled", "disabled");
   pdpButtons.classList.add("disabled");
   if (text) addButtonText.textContent = text;
  } else {
   addButton.removeAttribute("disabled");
   pdpButtons.classList.remove("disabled");
   addButtonText.textContent = window.variantStrings.addToCart;
  }

  if (!modifyClass) return;
 }

 setUnavailable() {
  const button = document.getElementById(
   `product-form-${this.dataset.section}`,
  );
  const addButton = button.querySelector('[name="add"]');
  const addButtonText = button.querySelector('[name="add"] > span');
  const price = document.getElementById(`price-${this.dataset.section}`);
  const inventory = document.getElementById(
   `Inventory-${this.dataset.section}`,
  );
  const sku = document.getElementById(`Sku-${this.dataset.section}`);
  const pricePerItem = document.getElementById(
   `Price-Per-Item-${this.dataset.section}`,
  );
  const volumeNote = document.getElementById(
   `Volume-Note-${this.dataset.section}`,
  );
  const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
  const qtyRules = document.getElementById(
   `Quantity-Rules-${this.dataset.section}`,
  );

  if (!addButton) return;
  addButtonText.textContent = window.variantStrings.unavailable;
  if (price) price.classList.add("hidden");
  if (inventory) inventory.classList.add("hidden");
  if (sku) sku.classList.add("hidden");
  if (pricePerItem) pricePerItem.classList.add("hidden");
  if (volumeNote) volumeNote.classList.add("hidden");
  if (volumeTable) volumeTable.classList.add("hidden");
  if (qtyRules) qtyRules.classList.add("hidden");
 }

 getVariantData() {
  this.variantData =
   this.variantData ||
   JSON.parse(this.querySelector('[type="application/json"]').textContent);
  return this.variantData;
 }
}

customElements.define("variant-selects", VariantSelects);

var defaultTitle = document.title;
window.addEventListener("focus", () => {
 document.title = defaultTitle;
});
window.addEventListener("blur", () => {
 document.title = "❤️ Komm‘ zurück";
});

document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) return;
  
  const links = Array.from(announcementBar.querySelectorAll(".announcement-bar__link"));
  if (links.length <= 1) return; // Only auto-rotate if multiple items
  
  let currentIndex = links.findIndex(link => link.classList.contains("active"));
  if (currentIndex === -1) currentIndex = 0;
  
  // Arrow handlers
  announcementBar.querySelectorAll(".announcement-bar__icon--next").forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      currentIndex = (currentIndex + 1) % links.length;
      links.forEach((link, i) => {
        link.classList.toggle("active", i === currentIndex);
      });
    });
  });
  
  announcementBar.querySelectorAll(".announcement-bar__icon--prev").forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      currentIndex = (currentIndex - 1 + links.length) % links.length;
      links.forEach((link, i) => {
        link.classList.toggle("active", i === currentIndex);
      });
    });
  });
  
  // Auto-rotate every 5 seconds (pause on hover)
  let interval;
  let isPaused = false;
  
  const startAutoRotate = () => {
    interval = setInterval(() => {
      if (!isPaused && !document.hidden) {
        currentIndex = (currentIndex + 1) % links.length;
        links.forEach((link, i) => {
          link.classList.toggle("active", i === currentIndex);
        });
      }
    }, 5000);
  };
  
  announcementBar.addEventListener("mouseenter", () => { isPaused = true; });
  announcementBar.addEventListener("mouseleave", () => { isPaused = false; });
  document.addEventListener("visibilitychange", () => {
    isPaused = document.hidden;
  });
  
  startAutoRotate();
  
  // Announcement close button
  const announcementCloseButton = document.querySelector('.utility-bar--close-button');
  if (announcementCloseButton) {
    announcementCloseButton.addEventListener('click', () => {
      announcementCloseButton.closest('.utility-bar').style.display = 'none';
    });
  }
});
